import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ManagementApiService } from './../../../../../services/management-api.service';
import { Component, OnInit, ChangeDetectorRef, OnDestroy, SimpleChanges } from '@angular/core';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { InstanceDataService } from 'src/app/services/instance-data.service';
import { Subject, Subscription } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { DeleteDialogComponent } from 'src/app/shared/info-dialogs/delete-dialog/delete-dialog.component';
import { CustomToastService } from 'src/app/services/custom-toast.service';
import { ProjectType, ProjectTypeStatus } from '../../../models/instance/project-type.model';
import { ViewProjectTypeModalComponent } from '../../modals/organization/view-project-type-modal/view-project-type-modal.component';
import { UserUtilityService } from 'src/app/services/user-utility.service';
import { AppConstants } from 'src/app/constants/appconstants';
import { takeUntil } from 'rxjs/operators';

@Component({
    selector: 'app-instance-project-type',
    templateUrl: './instance-project-type.component.html',
    styleUrls: ['./instance-project-type.component.scss'],
    standalone: false
})
export class InstanceProjectTypeComponent implements OnInit, OnDestroy {
    destroy$ = new Subject();
    defaultProjectTypesList: ProjectType[];
    newProjectTypesList: ProjectType[];
    defaultProjectSchema: string;
    defaultStatusTypeList: ProjectTypeStatus[];
    currentInstanceId: string;
    currentInstanceIdSubscription: Subscription;
    isNextButtonClicked: boolean;
    isProjectTypeSaved: boolean;
    isCheckUncheck: boolean;
    defaultProjectStatusList: ProjectTypeStatus[];
    isSaveDefultsave: boolean = false;
    tooltip_position = 'above';
    isNewInstance: boolean = false;
    constructor(
        private managementApiService: ManagementApiService,
        private ngxUiLoaderService: NgxUiLoaderService,
        private ngbModal: NgbModal,
        private instanceDataService: InstanceDataService,
        private activatedRoute: ActivatedRoute,
        private customToastService: CustomToastService,
        private user_utlity: UserUtilityService,
        private cd: ChangeDetectorRef,
        private router: Router
    ) {
        this.defaultProjectTypesList = [];
        this.newProjectTypesList = [];
        this.isNextButtonClicked = false;
        this.defaultStatusTypeList = [];
        this.isCheckUncheck = false;
    }

    ngOnInit(): void {
        this.instanceDataService.instanceActiveTab.pipe(takeUntil(this.destroy$)).subscribe((res) => {
            if (res == AppConstants.tab_projectTypes) {
                const url = this.router.url;
                if (url.includes('edit-instance')) {
                    this.isNewInstance = false;
                } else if (url.includes('add-instance')) {
                    this.isNewInstance = true;
                }
                this.getDefaultProjectStatus();
                if (!this.activatedRoute.snapshot.paramMap.get('id')) {
                    this.currentInstanceId = this.instanceDataService.instanceDetails?.instanceId;
                } else {
                    // instance edit mode
                    this.currentInstanceId = this.activatedRoute.snapshot.paramMap.get('id');
                }
                this.getProjectTypesByInstanceIdAPIcall();
            }
        });

        this.instanceDataService.instanceTabNext.pipe(takeUntil(this.destroy$)).subscribe((resp) => {
            if (resp == AppConstants.tab_projectTypes) {
                const selectednewProjectTypesList = this.newProjectTypesList?.filter((x) => x.isSelected == true).length > 0 ? true : false;
                const selecteddefaultProjectTypesList = this.defaultProjectTypesList?.filter((x) => x.isSelected == true).length > 0 ? true : false;

                if (selecteddefaultProjectTypesList || selectednewProjectTypesList) {
                    this.saveProjectTypes();
                } else {
                    this.customToastService.errorToast('Please select Project Type(s) to continue.', 'Error');
                }
            }
        });

        this.instanceDataService.instanceTabBack.pipe(takeUntil(this.destroy$)).subscribe((resp) => {
            if (resp == AppConstants.tab_projectTypes) {
                this.navigateBack();
            }
        });
    }

    navigateBack() {
        this.instanceDataService.instanceNavigationHandler(9);
    }

    // api to get default project types
    getDefaultProjectTypes() {
        if (!this.defaultProjectTypesList?.length) {
            this.ngxUiLoaderService.start();
            this.managementApiService.getDefaultProjectTypes().subscribe(
                (res) => {
                    this.ngxUiLoaderService.stop();
                    if (res.success === true) {
                        this.defaultProjectTypesList = res.response;
                        this.defaultProjectTypesList.forEach((item) => {
                            item.isSelected = false;
                        });

                        this.cd.detectChanges();
                        if (!this.activatedRoute.snapshot.paramMap.get('id')) {
                            if (!this.isSaveDefultsave) {
                                this.savePredDefinedProjectTypes();
                            }
                        }
                    } else {
                        this.user_utlity.errorModelPopup(res.message);
                    }
                },
                () => {
                    this.ngxUiLoaderService.stop();
                }
            );
        }
    }

    // view project type modal
    viewProjectType(projectType: ProjectType) {
        let dialogRef = this.ngbModal.open(ViewProjectTypeModalComponent, {
            size: 'lg',
            keyboard: false,
            backdrop: 'static',
        });
        dialogRef.componentInstance.modalMode = 'edit';
        dialogRef.componentInstance.projectType = projectType;
        dialogRef.componentInstance.defaultProjectStatusTypes = this.defaultProjectStatusList;
        dialogRef.componentInstance.projectTypeNameList = this.defaultProjectTypesList.map((type) => type.name);
        dialogRef.result.then(async (result: ProjectType) => {
            if (result) {
                await this.saveProjectTypeDetails(result);
            }
        });
    }

    // api call to save the default project types for instance
    nextButtonClick() {
        this.ngxUiLoaderService.start();
        this.managementApiService.saveProjectTypes(this.currentInstanceId, this.defaultProjectTypesList).subscribe(
            (response) => {
                this.ngxUiLoaderService.stop();
                this.defaultProjectTypesList = response;
                this.cd.detectChanges();
            },
            () => {
                this.ngxUiLoaderService.stop();
            }
        );
        this.instanceDataService.instanceNavigationHandler(8);
    }

    createProjectTypes() {
        let dialogRef = this.ngbModal.open(ViewProjectTypeModalComponent, {
            size: 'lg',
            keyboard: false,
            backdrop: 'static',
        });
        dialogRef.componentInstance.modalMode = 'add';
        dialogRef.componentInstance.projectTypeNameList = this.defaultProjectTypesList.map((type) => type.name);
        dialogRef.componentInstance.defaultProjectStatusTypes = this.defaultProjectStatusList;
        dialogRef.result
            .then(async (result) => {
                if (result) {
                    await this.saveProjectTypeDetails(result);
                }
            })
            .catch((e) => {
                console.warn(e);
            });
    }

    // api to save the project types
    saveProjectTypes() {
        if (this.newProjectTypesList.length > 0) {
            this.ngxUiLoaderService.start();
            this.managementApiService.updateProjectTypes(this.currentInstanceId, this.newProjectTypesList).subscribe(
                async (response) => {
                    this.ngxUiLoaderService.stop();
                    if (response.success) {
                        await this.getProjectTypesByInstanceIdAPIcall();
                        this.newProjectTypesList = [];
                        this.customToastService.successToast('Project types saved successfully', 'Success');
                        this.instanceDataService.instanceNavigationHandler(8);
                    } else if (response.isCustom) {
                        this.user_utlity.errorModelPopup(response.message);
                    }
                },
                () => {
                    this.ngxUiLoaderService.stop();
                }
            );
        } else {
            // if (!this.activatedRoute.snapshot.paramMap.get('id')) {
            //     this.customToastService.errorToast('Please select Project Type(s) to continue.', 'Error');
            // } else {
            //     this.instanceDataService.instanceNavigationHandler(8);
            // }
            this.instanceDataService.instanceNavigationHandler(8);
        }
    }

    // api to get the project type for instance
    async getProjectTypesByInstanceId() {
        if (!this.defaultProjectTypesList?.length) {
            await this.getProjectTypesByInstanceIdAPIcall();
        }
    }

    async getProjectTypesByInstanceIdAPIcall() {
        try {
            this.ngxUiLoaderService.start();
            let response = await this.managementApiService.getProjectTypesByInstanceId(this.currentInstanceId).toPromise();

            if (response.success) {
                this.defaultProjectTypesList = response.response;
                if (!response.response.length) {
                    this.getDefaultProjectTypes();
                }
                this.cd.detectChanges();
                this.ngxUiLoaderService.stop();
            } else {
                // this.user_utlity.errorModelPopup(response.message)
            }
        } catch (e) {
            this.ngxUiLoaderService.stop();
        }
    }

    deleteProjectType(projectTypeObj: ProjectType) {
        let deleteDialogRef = this.ngbModal.open(DeleteDialogComponent, {
            size: 'sm',
            keyboard: false,
            backdrop: 'static',
        });
        deleteDialogRef.componentInstance.modalMessage = `<p>Do you want to delete <b>${projectTypeObj.name}</b> project type? </p>`;
        deleteDialogRef.result
            .then((result) => {
                if (result) {
                    this.deleteProjectTypeFromDb(projectTypeObj.projectTypeId);
                }
            })
            .catch((e) => {
                console.warn(e);
            });
    }

    // helper method to get the index of particular activity type
    findIndexOfProjectType(projectTypeName: string, projectTypeArray: ProjectType[]) {
        let index = -1;
        for (const [index, projectType] of projectTypeArray.entries()) {
            if (projectType.name.toLocaleLowerCase().replace(/ /g, '') === projectTypeName.toLocaleLowerCase().replace(/ /g, '')) {
                return index;
            }
        }
        return index;
    }

    checkUncheckActivityPackType(event, projectType: ProjectType) {
        this.isCheckUncheck = true;
        let index = this.defaultProjectTypesList.findIndex((type) => type.projectTypeId == projectType.projectTypeId);
        if (index !== -1) {
            this.defaultProjectTypesList[index].isSelected = event.checked;
        }
        let targetIndex = this.newProjectTypesList.findIndex((type) => type.projectTypeId == projectType.projectTypeId);
        if (targetIndex == -1) {
            this.newProjectTypesList = [...this.newProjectTypesList, this.defaultProjectTypesList[index]];
        } else {
            this.newProjectTypesList[targetIndex] = this.defaultProjectTypesList[index];
        }
    }

    // * save predefined project types
    savePredDefinedProjectTypes(): void {
        this.ngxUiLoaderService.start();

        this.managementApiService.updateProjectTypes(this.currentInstanceId, this.defaultProjectTypesList).subscribe(
            (response) => {
                if (response.success) {
                    this.isNextButtonClicked = true;
                    this.isSaveDefultsave = true;
                    this.ngxUiLoaderService.stop();
                    this.getProjectTypesByInstanceIdAPIcall();
                } else if (response.isCustom) {
                }
            },
            () => {
                this.ngxUiLoaderService.stop();
            }
        );
    }

    // * api call to save project types
    async saveProjectTypeDetails(projectType: ProjectType) {
        try {
            if (!this.currentInstanceId) return;

            this.ngxUiLoaderService.start();
            let response = await this.managementApiService
                .updateProjectTypes(this.currentInstanceId, [...new Set([...this.newProjectTypesList, projectType])])
                .toPromise();

            this.ngxUiLoaderService.stop();
            if (response.success) {
                this.getProjectTypesByInstanceIdAPIcall();
                this.newProjectTypesList = [];
                this.customToastService.successToast('Project types saved successfully', 'Success');
            } else if (response.isCustom) {
                this.user_utlity.errorModelPopup(response.message);
            }
        } catch (e) {
            this.ngxUiLoaderService.stop();
            this.customToastService.errorToast('Error while saving the project types', 'Error');
        }
    }

    // * api call to delete the project type
    deleteProjectTypeFromDb(projectTypeId: string): void {
        let targetInd = this.newProjectTypesList.findIndex((item) => item.projectTypeId == projectTypeId);
        if (targetInd != -1) this.newProjectTypesList.splice(targetInd, 1);
        this.ngxUiLoaderService.start();
        this.managementApiService.updateProjectTypes(this.currentInstanceId, [{ projectTypeId: projectTypeId, active: false }]).subscribe(
            (response) => {
                this.ngxUiLoaderService.stop();
                if (response.success) {
                    this.customToastService.successToast('Project type deleted successfully!', 'Success');
                    if (!this.isCheckUncheck) {
                        this.getProjectTypesByInstanceIdAPIcall();
                    } else {
                        // * removing from array
                        let index = this.defaultProjectTypesList.findIndex((item) => item.projectTypeId == projectTypeId);
                        if (index != -1) {
                            this.defaultProjectTypesList.splice(index, 1);
                        }
                    }
                } else if (response.isCustom) {
                    this.user_utlity.errorModelPopup(response.message);
                }
            },
            () => {
                this.ngxUiLoaderService.stop();
            }
        );
    }

    // * api call to get the default project type status
    getDefaultProjectStatus() {
        if (!this.defaultProjectStatusList?.length) {
            this.ngxUiLoaderService.start();
            this.managementApiService.getDefaultStatusTypeForProject().subscribe((res) => {
                this.ngxUiLoaderService.stop();
                if (res.success) {
                    this.defaultProjectStatusList = res.response;
                } else if (res.isCustom) {
                }
            });
        }
    }

    cancelButtonClick() {}

    ngOnDestroy(): void {
        this.destroy$.next(null);
        this.destroy$.complete();
    }
}
